const getCssUnit = (originalSize: string): string => {
  const sizeValue: number = parseFloat(originalSize);
  if (!Number.isNaN(sizeValue) && originalSize.trim() !== '') {
    const sizeUnit: string = originalSize.replace(sizeValue.toString(), '').trim();
    return sizeUnit;
  }
  return '';
};

export default getCssUnit;
